// src/components/strumenti/ConsumoAdesivo.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function ConsumoAdesivo() {
  const [superficie, setSuperficie] = useState("");
  const [consumoMq, setConsumoMq] = useState("4");
  const [pesoSacco, setPesoSacco] = useState("25");

  const S = leggiNumero(superficie)||0;
  const consumo = leggiNumero(consumoMq)||0;
  const sacco = leggiNumero(pesoSacco)||25;

  const kgTotali = S*consumo;
  const numSacchi = sacco>0 ? Math.ceil(kgTotali/sacco) : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Superficie da posare (m²)</label>
          <input value={superficie} onChange={e=>setSuperficie(e.target.value)} style={inp} placeholder="Es. 25"/>
        </div>
        <div>
          <label style={lbl}>Consumo adesivo (kg/m²)</label>
          <input value={consumoMq} onChange={e=>setConsumoMq(e.target.value)} style={inp} placeholder="Es. 4"/>
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Peso sacco (kg)</label>
        <input value={pesoSacco} onChange={e=>setPesoSacco(e.target.value)} style={inp}/>
      </div>

      <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around" }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Adesivo necessario</div>
            <div style={{ fontSize:20, fontWeight:800, color:"#374151" }}>{S>0 ? kgTotali.toLocaleString("it-IT",{maximumFractionDigits:1}) : "—"} kg</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>N° sacchi</div>
            <div style={{ fontSize:22, fontWeight:800, color:"#15803d" }}>{numSacchi ?? "—"}</div>
          </div>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Il consumo kg/m² varia molto in base a dentatura della spatola e planarità del fondo — verificare sempre il dato dichiarato dal produttore dell'adesivo.
      </div>

      <button onClick={()=>{setSuperficie("");setConsumoMq("4");setPesoSacco("25");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
